import { handleActions } from "redux-actions";
import { AsyncStates } from "../../constants";
import { AnalysisCreateActionTypes, AnalysisDatasetActionTypes, AnalysisDetailsActionTypes, AnalysisListActionTypes, analysisModelSelectionActionTypes, AnalysisUpdateActionTypes, DWTAnalysisActionTypes, DWTTransformActionTypes, favoriteModelsActionTypes, modelEvaluationActionTypes, OperationConfigsActionTypes, OperationCreateActionTypes, OperationDatasetAddActionTypes, OperationDetailsActionTypes, OperationListActionTypes, selectedModelsActionTypes, TrainingActionTypes, TrainingResultsActionTypes } from "../actions/operations";


export type OperationsReducerState = {
    operationConfigsStatus: AsyncStates
    operationConfigsData: any,
    operationConfigsError: string

    operationCreateStatus: AsyncStates
    operationCreateData: any,
    operationCreateError: string

    operationListStatus: AsyncStates
    operationListData: any,
    operationListError: string

    operationDetailsStatus: AsyncStates
    operationDetailsData: any,
    operationDetailsError: string

    operationDatasetAddStatus: AsyncStates
    operationDatasetAddData: any,
    operationDatasetAddError: string

    analysisListStatus: AsyncStates
    analysisListData: any,
    analysisListError: string

    analysisCreateStatus: AsyncStates
    analysisCreateData: any,
    analysisCreateError: string

    analysisDatasetStatus: AsyncStates
    analysisDatasetData: any,
    analysisDatasetError: string

    analysisDetailsStatus: AsyncStates
    analysisDetailsData: any,
    analysisDetailsError: string

    analysisUpdateStatus: AsyncStates
    analysisUpdateData: any,
    analysisUpdateError: string

    dwtAnalysisStatus: AsyncStates
    dwtAnalysisData: any,
    dwtAnalysisError: string

    dwtTransformStatus: AsyncStates
    dwtTransformData: any,
    dwtTransformError: string

    trainingStatus: AsyncStates
    trainingData: any,
    trainingError: string

    trainingResultsStatus: AsyncStates
    trainingResultsData: any,
    trainingResultsError: string

    analysisModelSelectionStatus: AsyncStates
    analysisModelSelectionData: any,
    analysisModelSelectionError: string

    modelEvaluationStatus: AsyncStates
    modelEvaluationData: any,
    modelEvaluationError: string

    selectedModelsStatus: AsyncStates
    selectedModelsData: any,
    selectedModelsError: string

    favoriteModelsStatus: AsyncStates
    favoriteModelsData: any,
    favoriteModelsError: string
}

const defaultState: OperationsReducerState = {
    operationConfigsStatus: AsyncStates.INITIAL,
    operationConfigsData: { dataset_types: [] },
    operationConfigsError: "",

    operationCreateStatus: AsyncStates.INITIAL,
    operationCreateData: {},
    operationCreateError: "",

    operationListStatus: AsyncStates.INITIAL,
    operationListData: [],
    operationListError: "",

    operationDetailsStatus: AsyncStates.INITIAL,
    operationDetailsData: {},
    operationDetailsError: "",

    operationDatasetAddStatus: AsyncStates.INITIAL,
    operationDatasetAddData: {},
    operationDatasetAddError: "",

    analysisListStatus: AsyncStates.INITIAL,
    analysisListData: [],
    analysisListError: "",

    analysisCreateStatus: AsyncStates.INITIAL,
    analysisCreateData: {},
    analysisCreateError: "",

    analysisDatasetStatus: AsyncStates.INITIAL,
    analysisDatasetData: {},
    analysisDatasetError: "",

    analysisDetailsStatus: AsyncStates.INITIAL,
    analysisDetailsData: {},
    analysisDetailsError: "",

    analysisUpdateStatus: AsyncStates.INITIAL,
    analysisUpdateData: {},
    analysisUpdateError: "",

    dwtAnalysisStatus: AsyncStates.INITIAL,
    dwtAnalysisData: {},
    dwtAnalysisError: "",

    dwtTransformStatus: AsyncStates.INITIAL,
    dwtTransformData: {},
    dwtTransformError: "",

    trainingStatus: AsyncStates.INITIAL,
    trainingData: {},
    trainingError: "",

    trainingResultsStatus: AsyncStates.INITIAL,
    trainingResultsData: {},
    trainingResultsError: "",
    
    analysisModelSelectionStatus: AsyncStates.INITIAL,
    analysisModelSelectionData: [],
    analysisModelSelectionError: "",

    modelEvaluationStatus: AsyncStates.INITIAL,
    modelEvaluationData: {},
    modelEvaluationError: "",

    selectedModelsStatus: AsyncStates.INITIAL,
    selectedModelsData: [],
    selectedModelsError: "",

    favoriteModelsStatus: AsyncStates.INITIAL,
    favoriteModelsData: [],
    favoriteModelsError: ""
}

const operationsReducer = handleActions({
    [OperationConfigsActionTypes.REQUEST]: (state) => ({
        ...state,
        operationConfigsStatus: AsyncStates.LOADING,
    }),
    [OperationConfigsActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        operationConfigsStatus: AsyncStates.SUCCESS,
        operationConfigsData: action.payload?.data
    }),
    [OperationConfigsActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        operationConfigsStatus: AsyncStates.ERROR,
        operationConfigsError: action.payload.error
    }),
    [OperationConfigsActionTypes.CLEAR]: (state) => ({
        ...state,
        operationConfigsStatus: AsyncStates.INITIAL,
        operationConfigsData: {},
        operationConfigsError: ""
    }),

    [OperationCreateActionTypes.REQUEST]: (state) => ({
        ...state,
        operationCreateStatus: AsyncStates.LOADING,
    }),
    [OperationCreateActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        operationCreateStatus: AsyncStates.SUCCESS,
        operationCreateData: action.payload.message
    }),
    [OperationCreateActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        operationCreateStatus: AsyncStates.ERROR,
        operationCreateError: action.payload.error
    }),
    [OperationCreateActionTypes.CLEAR]: (state) => ({
        ...state,
        operationCreateStatus: AsyncStates.INITIAL,
        operationCreateData: {},
        operationCreateError: ""
    }),

    [OperationListActionTypes.REQUEST]: (state, action) => ({
        ...state,
        operationListStatus: AsyncStates.LOADING,
    }),
    [OperationListActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        operationListStatus: AsyncStates.SUCCESS,
        operationListData: action.payload?.data
    }),
    [OperationListActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        operationListStatus: AsyncStates.ERROR,
        operationListError: action.payload.message
    }),
    [OperationListActionTypes.CLEAR]: (state) => ({
        ...state,
        operationListStatus: AsyncStates.INITIAL,
        operationListData: [],
        operationListError: '',
    }),

    [OperationDetailsActionTypes.REQUEST]: (state, action) => ({
        ...state,
        operationDetailsStatus: AsyncStates.LOADING,
    }),
    [OperationDetailsActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        operationDetailsStatus: AsyncStates.SUCCESS,
        operationDetailsData: action.payload?.data
    }),
    [OperationDetailsActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        operationDetailsStatus: AsyncStates.ERROR,
        operationDetailsError: action.payload.message
    }),
    [OperationDetailsActionTypes.CLEAR]: (state) => ({
        ...state,
        operationDetailsStatus: AsyncStates.INITIAL,
        operationDetailsData: [],
        operationDetailsError: '',
    }),

    [OperationDatasetAddActionTypes.REQUEST]: (state, action) => ({
        ...state,
        operationDatasetAddStatus: AsyncStates.LOADING,
    }),
    [OperationDatasetAddActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        operationDatasetAddStatus: AsyncStates.SUCCESS,
        operationDatasetAddData: action.payload?.data
    }),
    [OperationDatasetAddActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        operationDatasetAddStatus: AsyncStates.ERROR,
        operationDatasetAddError: action.payload.message
    }),
    [OperationDatasetAddActionTypes.CLEAR]: (state) => ({
        ...state,
        operationDatasetAddStatus: AsyncStates.INITIAL,
        operationDatasetAddData: [],
        operationDatasetAddError: '',
    }),

    [AnalysisListActionTypes.REQUEST]: (state, action) => ({
        ...state,
        analysisListStatus: AsyncStates.LOADING,
    }),
    [AnalysisListActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        analysisListStatus: AsyncStates.SUCCESS,
        analysisListData: action.payload?.data
    }),
    [AnalysisListActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        analysisListStatus: AsyncStates.ERROR,
        analysisListError: action.payload.message
    }),
    [AnalysisListActionTypes.CLEAR]: (state) => ({
        ...state,
        analysisListStatus: AsyncStates.INITIAL,
        analysisListData: [],
        analysisListError: '',
    }),

    [AnalysisCreateActionTypes.REQUEST]: (state) => ({
        ...state,
        analysisCreateStatus: AsyncStates.LOADING,
    }),
    [AnalysisCreateActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        analysisCreateStatus: AsyncStates.SUCCESS,
        analysisCreateData: action.payload.message
    }),
    [AnalysisCreateActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        analysisCreateStatus: AsyncStates.ERROR,
        analysisCreateError: action.payload.error
    }),
    [AnalysisCreateActionTypes.CLEAR]: (state) => ({
        ...state,
        analysisCreateStatus: AsyncStates.INITIAL,
        analysisCreateData: {},
        analysisCreateError: ""
    }),

    [analysisModelSelectionActionTypes.REQUEST]: (state) => ({
        ...state,
        analysisModelSelectionStatus: AsyncStates.LOADING,
    }),
    [analysisModelSelectionActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        analysisModelSelectionStatus: AsyncStates.SUCCESS,
        analysisModelSelectionData: action.payload.message
    }),
    [analysisModelSelectionActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        analysisModelSelectionStatus: AsyncStates.ERROR,
        analysisModelSelectionError: action.payload.error
    }),
    [analysisModelSelectionActionTypes.CLEAR]: (state) => ({
        ...state,
        analysisModelSelectionStatus: AsyncStates.INITIAL,
        analysisModelSelectionData: {},
        analysisModelSelectionError: ""
    }),

    [AnalysisDatasetActionTypes.REQUEST]: (state) => ({
        ...state,
        analysisDatasetStatus: AsyncStates.LOADING,
    }),
    [AnalysisDatasetActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        analysisDatasetStatus: AsyncStates.SUCCESS,
        analysisDatasetData: action.payload?.data
    }),
    [AnalysisDatasetActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        analysisDatasetStatus: AsyncStates.ERROR,
        analysisDatasetError: action.payload.error
    }),
    [AnalysisDatasetActionTypes.CLEAR]: (state) => ({
        ...state,
        analysisDatasetStatus: AsyncStates.INITIAL,
        analysisDatasetData: {},
        analysisDatasetError: ""
    }),

    [AnalysisDetailsActionTypes.REQUEST]: (state) => ({
        ...state,
        analysisDetailsStatus: AsyncStates.LOADING,
    }),
    [AnalysisDetailsActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        analysisDetailsStatus: AsyncStates.SUCCESS,
        analysisDetailsData: action.payload?.data
    }),
    [AnalysisDetailsActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        analysisDetailsStatus: AsyncStates.ERROR,
        analysisDetailsError: action.payload.error
    }),
    [AnalysisDetailsActionTypes.CLEAR]: (state) => ({
        ...state,
        analysisDetailsStatus: AsyncStates.INITIAL,
        analysisDetailsData: {},
        analysisDetailsError: ""
    }),

    [TrainingActionTypes.REQUEST]: (state) => ({
        ...state,
        trainingStatus: AsyncStates.LOADING,
    }),
    [TrainingActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        trainingStatus: AsyncStates.SUCCESS,
        trainingData: action.payload?.data
    }),
    [TrainingActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        trainingStatus: AsyncStates.ERROR,
        trainingError: action.payload.error
    }),
    [TrainingActionTypes.CLEAR]: (state) => ({
        ...state,
        trainingStatus: AsyncStates.INITIAL,
        trainingData: {},
        trainingError: ""
    }),

    [TrainingResultsActionTypes.REQUEST]: (state) => ({
        ...state,
        trainingResultsStatus: AsyncStates.LOADING,
    }),
    [TrainingResultsActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        trainingResultsStatus: AsyncStates.SUCCESS,
        trainingResultsData: action.payload?.data
    }),
    [TrainingResultsActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        trainingResultsStatus: AsyncStates.ERROR,
        trainingResultsError: action.payload.error
    }),
    [TrainingResultsActionTypes.CLEAR]: (state) => ({
        ...state,
        trainingResultsStatus: AsyncStates.INITIAL,
        trainingResultsData: {},
        trainingResultsError: ""
    }),

    [AnalysisUpdateActionTypes.REQUEST]: (state) => ({
        ...state,
        analysisUpdateStatus: AsyncStates.LOADING,
    }),
    [AnalysisUpdateActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        analysisUpdateStatus: AsyncStates.SUCCESS,
        analysisUpdateData: action.payload?.data
    }),
    [AnalysisUpdateActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        analysisUpdateStatus: AsyncStates.ERROR,
        analysisUpdateError: action.payload.error
    }),
    [AnalysisUpdateActionTypes.CLEAR]: (state) => ({
        ...state,
        analysisUpdateStatus: AsyncStates.INITIAL,
        analysisUpdateData: {},
        analysisUpdateError: ""
    }),

    [DWTAnalysisActionTypes.REQUEST]: (state) => ({
        ...state,
        dwtAnalysisStatus: AsyncStates.LOADING,
    }),
    [DWTAnalysisActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        dwtAnalysisStatus: AsyncStates.SUCCESS,
        dwtAnalysisData: action.payload?.data
    }),
    [DWTAnalysisActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        dwtAnalysisStatus: AsyncStates.ERROR,
        dwtAnalysisError: action.payload.error
    }),
    [DWTAnalysisActionTypes.CLEAR]: (state) => ({
        ...state,
        dwtAnalysisStatus: AsyncStates.INITIAL,
        dwtAnalysisData: {},
        dwtAnalysisError: ""
    }),

    [DWTTransformActionTypes.REQUEST]: (state) => ({
        ...state,
        dwtTransformStatus: AsyncStates.LOADING,
    }),
    [DWTTransformActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        dwtTransformStatus: AsyncStates.SUCCESS,
        dwtTransformData: action.payload?.data
    }),
    [DWTTransformActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        dwtTransformStatus: AsyncStates.ERROR,
        dwtTransformError: action.payload.error
    }),
    [DWTTransformActionTypes.CLEAR]: (state) => ({
        ...state,
        dwtTransformStatus: AsyncStates.INITIAL,
        dwtTransformData: {},
        dwtTransformError: ""
    }),

    [modelEvaluationActionTypes.REQUEST]: (state) => ({
        ...state,
        modelEvaluationStatus: AsyncStates.LOADING,
    }),
    [modelEvaluationActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        modelEvaluationStatus: AsyncStates.SUCCESS,
        modelEvaluationData: action.payload?.data
    }),
    [modelEvaluationActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        modelEvaluationStatus: AsyncStates.ERROR,
        modelEvaluationError: action.payload.error
    }),
    [modelEvaluationActionTypes.CLEAR]: (state) => ({
        ...state,
        modelEvaluationStatus: AsyncStates.INITIAL,
        modelEvaluationData: {},
        modelEvaluationError: ""
    }),

    [selectedModelsActionTypes.REQUEST]: (state) => ({
        ...state,
        selectedModelsStatus: AsyncStates.LOADING,
    }),
    [selectedModelsActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        selectedModelsStatus: AsyncStates.SUCCESS,
        selectedModelsData: action.payload?.data
    }),
    [selectedModelsActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        selectedModelsStatus: AsyncStates.ERROR,
        selectedModelsError: action.payload.error
    }),
    [selectedModelsActionTypes.CLEAR]: (state) => ({
        ...state,
        favoriteModelsStatus: AsyncStates.INITIAL,
        favoriteModelsData: [],
        favoriteModelsError: ""
    }),

    [favoriteModelsActionTypes.REQUEST]: (state) => ({
        ...state,
        favoriteModelsStatus: AsyncStates.LOADING,
    }),
    [favoriteModelsActionTypes.SUCCESS]: (state, action: any) => ({
        ...state,
        favoriteModelsStatus: AsyncStates.SUCCESS,
        favoriteModelsData: action.payload?.data
    }),
    [favoriteModelsActionTypes.FAILURE]: (state, action: any) => ({
        ...state,
        favoriteModelsStatus: AsyncStates.ERROR,
        favoriteModelsError: action.payload.error
    }),
    [favoriteModelsActionTypes.CLEAR]: (state) => ({
        ...state,
        favoriteModelsStatus: AsyncStates.INITIAL,
        favoriteModelsData: [],
        favoriteModelsError: ""
    }),
}, defaultState)


export default operationsReducer